import {
  CertificationVM,
  CertificationForm,
  CertificationFormOptions,
  UpdateCertificationRequest,
  AddCommentRequest,
  CertificationSlimVM,
} from "@/types/certifications";
import { CommentModel } from "@/types/comments";
import { ref, Ref, computed, watch } from "vue";
import { $api } from "@/services/api1";
import functions from "@/use/functions";
import * as yup from "yup";
import { useRoute } from "vue-router";

export function useCertification() {
  const route = useRoute();
  const isLoading = ref<boolean>(false);
  const certification = ref<CertificationVM | null>();

  async function getCertification(certificationId?: number) {
    if (certificationId && certificationId !== 0) {
      const response = await $api.certifications.getCertification(
        certificationId
      );

      return response;
    }
  }

  return { certification, getCertification };
}

export function useCommentModal(certificationVM: Ref<CertificationVM>) {
  const isSubmitting = ref<boolean>(false);

  const comments = ref<CommentModel[] | null>([]);

  const value = ref<CertificationVM | null>(null);

  const commentSchema = computed(() => {
    return yup.string().required("Comment is required");
  });

  function setComments(data: CommentModel[]) {
    comments.value = data;
  }

  async function addComment(comment?: string | null) {
    isSubmitting.value = true;
    const response = await $api.certifications.addComment({
      certificationId: certificationVM.value.form.id,
      appId: certificationVM.value.appId,
      loanId: certificationVM.value.loanId,
      comment: comment,
    });

    if (response === true) {
      isSubmitting.value = false;
      functions.openModal("Your comment has been added!");
      return true;
    } else {
      functions.openModal("Error: Comment was not saved!");
      isSubmitting.value = false;
      return false;
    }
  }

  async function getComments() {
    let commentData: CommentModel[] = [];

    await $api.certifications
      .getComments({
        certificationId: certificationVM.value.form.id,
        appId: certificationVM.value.appId,
        loanId: certificationVM.value.loanId,
      })
      .then((response) => {
        if (Array.isArray(response) && response.length >= 1) {
          setComments(response);
          commentData = response;
        }
      })
      .catch((error) => {
        console.log(`API Error: getComments()`, error);
        functions.openModal("Error: Comments could not be loaded!");
      });

    return commentData;
  }

  return {
    comments,
    value,
    addComment,
    getComments,
    setComments,
    isSubmitting,
    commentSchema,
  };
}
